export default __webpack_public_path__ + "static/media/btn-gnb-pin.b638458a.svg";